import { ImageHelper } from '@/lib/helpers/image.helper'

// N7 `?aio=w-*` width cho ảnh hero mobile.
export const HOME_HERO_MOBILE_N7_WIDTH = 672

const HERO_DESIGN_WIDTH = 1440
const HERO_DESIGN_HEIGHT = 590

export function getHomeHeroMobileN7ImageUrl(mbImage: string): string {
  return ImageHelper.getImageUrl(mbImage, '', HOME_HERO_MOBILE_N7_WIDTH)
}

export function getHomeHeroMobileDisplaySize(): Readonly<{
  width: number
  height: number
}> {
  const width = HOME_HERO_MOBILE_N7_WIDTH
  const height = Math.round((HERO_DESIGN_HEIGHT * width) / HERO_DESIGN_WIDTH)
  return { width, height }
}
